"use strict";
/*
 * Created on 07 05 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization API of {@link SelloutTypeWithItemCounts}.
 *
 * @author JMe
 */


var SelloutTypeWithItemCountsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTypeWithItemCountsConverter, _DataObjectConverter_);

  function SelloutTypeWithItemCountsConverter() {
    _classCallCheck(this, SelloutTypeWithItemCountsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTypeWithItemCountsConverter).apply(this, arguments));
  }

  return SelloutTypeWithItemCountsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTypeWithItemCountsConverter = SelloutTypeWithItemCountsConverter;